import {v4 as uuid} from "uuid";
import {NodeFileSearchControl, LabelTextAreaControl} from "../../controls";
import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import {RemoveButtonControl} from "../../controls/RemoveButtonControl";
import {ResourceType} from "models/ResourceType";

export class Info {

    constructor(parentComponent, infoAdded, infoRemoved) {
        this.parentComponent = parentComponent;
        this.onInfoAdded = infoAdded;
        this.onInfoRemoved = infoRemoved;
        this.isAdded = false;
    }

    addInfo(node, infoUUID = null) {
        if (infoUUID == null) {
            infoUUID = uuid();
        }

        const iconFileControl = new NodeFileSearchControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getInfoIconFileKey(infoUUID),
            node,
            ResourceType.NodeInfoIcon,
            false,
            "Icon file"
        );

        const textControl = new LabelTextAreaControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getInfoTextKey(infoUUID),
            node,
            false,
            "Info text"
        );

        const removeInfoControl = new RemoveButtonControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getInfoRemoveButtonKey(infoUUID),
            node,
            false,
            () => this.onRemoveInfoClick.bind(this, node, infoUUID, removeInfoControl, iconFileControl, textControl)
        );

        node
            .addControl(removeInfoControl)
            .addControl(iconFileControl)
            .addControl(textControl)

        this.infoAdded(node, infoUUID);
        node.update();
    }

    infoAdded(node, addedInfoUUID) {
        if (node.infoIds === undefined) {
            node.infoIds = [];
        }

        node.infoIds.push(addedInfoUUID);

        this.isAdded = true;
        this.onInfoAdded();
    }

    onRemoveInfoClick(node, infoUUID, removeInfoControl, iconFileControl, textControl) {
        this.removeInfo(node, infoUUID, removeInfoControl, iconFileControl, textControl)
            .then(r => {
                this.infoRemoved(node, infoUUID);
            });
    }

    async removeInfo(node, infoUUID, removeInfoControl, iconFileControl, textControl,) {
        node.removeControl(removeInfoControl);
        node.removeControl(iconFileControl);
        node.removeControl(textControl);

        node.update();

        delete node.data[SequenceComponentHelper.getInfoIconFileKey(infoUUID)];
        delete node.data[SequenceComponentHelper.getInfoTextKey(infoUUID)];
    }

    async infoRemoved(node, removedInfoUUID) {
        const indexOfRemovedInfo = node.infoIds.indexOf(removedInfoUUID);
        if (indexOfRemovedInfo === -1) {
            console.error(`Unexpected error occurred. There is no Info of id '${removedInfoUUID}' to remove.`)
        }

        node.infoIds.splice(indexOfRemovedInfo, 1);

        this.isAdded = false;
        this.onInfoRemoved();
    }
}